import React, { Component } from 'react';

import Header from '../components/Header';
import OldHeader from '../components/OldHeader';
import Footer from '../components/Footer';
import MapperControl from '../components/MapperControl';
import Legend from '../components/Legend';
import DPCSection from '../components/DPCSection';
import AboutMapperSection from '../components/AboutMapperSection';
import AddYourself from '../components/AddYourself';
// import '../style/HomePage.scss';

class HomePage extends Component {
  state = {
    numPracs: null,
  };

  render() {
    // fetch('http://ip-api.com/json').then(async resp => {
    // let val = await resp.json();
    // console.log(JSON.stringify(val, null, 2));
    // });

    return (
      <div>
        <div className="wide">
          {false ? <Header /> : <OldHeader />}

          <div className="HomePage">
            <div className="row HeaderRow">
              <div className="col">
                <h1>DPC Frontier Mapper</h1>
                <p>
                  The map below displays the locations of{' '}
                  {this.state.numPracs || 'all known'} direct primary care (DPC)
                  practices across 48 states plus Washington, DC. Click{' '}
                  <a href="https://www.dpcfrontier.com/defined">here</a> to
                  learn more about direct primary care.
                </p>
              </div>
            </div>
            {false && (
              <div className="wide">
                <iframe
                  src="http://localhost:3000/iframe"
                  title="DPC Frontier Mapper"
                  style={{ height: '750px' }}
                />
              </div>
            )}
            <Legend />
            <MapperControl
              setNumPracs={numPracs => {
                this.setState({ numPracs: numPracs });
              }}
            />

            <DPCSection />
            <AboutMapperSection numPracs={this.state.numPracs} />
            <AddYourself />
          </div>

          <br />
          <br />
          <br />
          <Footer />
        </div>
      </div>
    );
  }
}

export default HomePage;
